import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import zrxQuestions from 'images/coin-pages/questions/0x.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const zrxPage: ICoinPageData = {
  title: 'coin_1258',
  description: 'coin_1259',
  // description:
  //   'Borrow 0x against Stablecoins.' +
  //   ` Get a stablecoin loan using your ZRX coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, locale, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'ZRX' }) }} />
  ),
  questionsBlock: {
    image: zrxQuestions,
    questions: [
      {
        title: 'coin_1260',
        answer: 'coin_1261',
      },
      {
        title: 'coin_1262',
        answer: 'coin_1263',
      },
      {
        title: 'coin_1264',
        answer: 'coin_1265',
      },
      {
        title: 'coin_1266',
        answer: 'coin_1267',
      },
      {
        title: 'coin_1268',
        answer: 'coin_1269',
      },
      {
        title: 'coin_1270',
        answer: 'coin_1271',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('0x (ZRX)'),
    text: ['coin_1276', 'coin_1277'],
    paragraphs: [
      {
        title: 'coin_1272',
        text: ['coin_1278', 'coin_1279'],
      },
      {
        title: 'coin_1273',
        text: ['coin_1280', 'coin_1281', 'coin_1282'],
      },
      {
        title: 'coin_1274',
        text: [
          'coin_1283',
          'coin_1284',
          'coin_1285',
          'coin_1286',
          'coin_1287',
          'coin_1288',
          'coin_1289',
          'coin_1290',
          'coin_1291',
        ],
      },
      {
        title: 'coin_1275',
        text: ['coin_1292', 'coin_1293', 'coin_1294', 'coin_1295', 'coin_1296'],
      },
    ],
    ...commonLearnMoreData('0x (ZRX)'),
  },
}
